import { Pagination } from "react-bootstrap";

const MAX_ITEMS = 9;
const MAX_LEFT = (MAX_ITEMS - 1) / 2;

const PaginationMydna = ({ limit, total, setPage, page }) => {
    const pages = Math.ceil(total / limit);
    const first = Math.max(page - MAX_LEFT, 1);

    const onPageChange = (current) => {
        setPage(current);
    };

    return (
        <Pagination>
            <Pagination.First onClick={() => setPage(1) } disabled={page === 1} />
            <Pagination.Prev onClick={() => { setPage(page - 1) }} disabled={page === 1} />
            {Array.from({ length: Math.min(MAX_ITEMS, pages) })
                .map((_, index) => index + first)
                .map((currentPage) => {
                    if (currentPage <= pages)
                        return (
                            <Pagination.Item
                                key={currentPage}
                                onClick={() => onPageChange(currentPage)}
                                active={currentPage === page}
                            >
                                {currentPage}
                            </Pagination.Item>
                        )
                    return null
                })}
            <Pagination.Next onClick={() => { setPage(page + 1) }} disabled={page === pages} />
            <Pagination.Last onClick={() => setPage(pages) } disabled={page === pages} />
        </Pagination>
    );
};
export default PaginationMydna;
